<div class="responsive-container">
  <app-progress/>
  <div class="coverage-container">
    <div class="app-next-prev-wrapper">
      <app-next-prev/>
    </div>
  </div>
</div>
